<template>
    <form ref="form" @submit="handleAccountRecovery" novalidate>
        <div class="modal-dialog" style="min-width: 400px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Recover Account</h5>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger" v-if="errorMessage">
                        {{errorMessage}}
                    </div>
                    <div class="alert alert-success" v-if="successMessage">
                        {{successMessage}}
                    </div>
                    <div class="form-group row mb-2">
                        <div class="col input-container has-validation">
                            <input type="text"
                                class="form-control"
                                placeholder="Username"
                                v-model="username"
                                ref="username"
                                required
                                :disabled="busy"
                                />
                        </div>
                    </div>                    
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary text-center" :disabled="busy">{{busy ? 'Recovering...' : 'Recover Account'}}</button>
                    </div>
                </div>
                <div class="modal-footer bg-light small" style="justify-content: space-between">
                    <router-link v-if="$router.hasRoute('alzata:account/login')" :to="{ name: 'alzata:account/login' }">Sign In</router-link>
                    <!-- <router-link v-if="$router.hasRoute('alzata:account/create')" :to="{ name: 'alzata:account/create' }">Sign Up</router-link> -->
                </div>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'AlzataRecoverAccount',
    data: () => ({
        username: '',        
        errorMessage: null,
        successMessage: null,
        busy: false,
        formWasValidated: false,
    }),
    mounted() {
        this.$refs.username.focus();
    },
    methods: {        
        async handleAccountRecovery(evt) {
            evt.preventDefault();
            this.errorMessage = null;

            this.busy = true;
            try {
                const result = await this.apiClient.recover(this.username);                
                if (result.success) {
                    this.successMessage = "Recovery Account Email Has Been Sent.";
                    window.setTimeout(() => this.$router.replace('/account/login'), 5000);
                }
                else {
                    this.errorMessage = "Failed To Recover Account.";
                    window.setTimeout(() => this.$refs.username.focus(), 5000);
                }
            }
            finally {
                this.busy = false;
            }
        },
    },
};
</script>